<template>
  <van-tabbar
    v-model="active"
    safe-area-inset-bottom
    active-color="#D5001C"
    inactive-color="#403F45"
  >
    <van-tabbar-item to="/index" v-if="userType == '0'">
      <span>{{ companyType }}</span>
      <template #icon="props">
        <img
          :src="
            props.active
              ? require('@/assets/img/passportMainCheck.png')
              : require('@/assets/img/passportMain.png')
          "
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/dealerIndex" v-if="userType == '1'">
      <span>PC护照</span>
      <template #icon="props">
        <img
          :src="
            props.active
              ? require('@/assets/img/passportMainCheck.png')
              : require('@/assets/img/passportMain.png')
          "
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/user/passport">
      <!-- <span>{{ userType != '2' ? '我的护照' : '培训护照' }}</span> -->
      <span>我的护照</span>
      <template #icon="props">
        <img
          :src="
            props.active
              ? require('@/assets/img/passportCheck.png')
              : require('@/assets/img/passport.png')
          "
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/user/course">
      <span>我的课程</span>
      <template #icon="props">
        <img
          :src="
            props.active
              ? require('@/assets/img/courseCheck.png')
              : require('@/assets/img/course.png')
          "
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/user/userCenter">
      <span>个人中心</span>
      <template #icon="props">
        <img
          :src="props.active ? require('@/assets/img/myCheck.png') : require('@/assets/img/my.png')"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'list',
  data() {
    return {
      active: 0,
      userType: localStorage.getItem('userType'),
      companyType: JSON.parse(localStorage.getItem('user')).companyType,
    }
  },
  watch: {
    $route(val) {
      if (val.name == 'Index' || val.name == 'DealerIndex') {
        this.active = 0
      } else if (val.name == 'Passport') {
        this.active = this.userType == '2' ? 0 : 1
      } else if (val.name == 'Course') {
        this.active = this.userType == '2' ? 1 : 2
      } else if (val.name == 'userCenter') {
        this.active = this.userType == '2' ? 2 : 3
      }
      if (val.name == 'DealerIndex' && this.userType == '0') {
        //当为集团角色进入经销商首页时，改变tab文字
        this.companyType = 'PC护照'
      } else {
        this.companyType = JSON.parse(localStorage.getItem('user')).companyType
      }
    },
  },
  // 通过路由跳转判断选中的样式
  created() {
    if (this.$route.name == 'Index' || this.$route.name == 'DealerIndex') {
      this.active = 0
    } else if (this.$route.name == 'Passport') {
      this.active = this.userType == '2' ? 0 : 1
    } else if (this.$route.name == 'Course') {
      this.active = this.userType == '2' ? 1 : 2
    } else if (this.$route.name == 'userCenter') {
      this.active = this.userType == '2' ? 2 : 3
    }
    if (this.$route.name == 'DealerIndex' && this.userType == '0') {
      //当为集团角色进入经销商首页时，改变tab文字
      this.companyType = 'PC护照'
    } else {
      this.companyType = JSON.parse(localStorage.getItem('user')).companyType
      if(this.companyType  == '' || this.companyType == null){
        this.companyType = 'TA护照'
      }
    }
  },
  mounted() {},
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.van-hairline--top-bottom:after,
.van-hairline-unset--top-bottom:after {
  border-width: 1px 0 0 0 !important;
}
.van-tabbar--fixed {
  box-sizing: border-box;
  height: 60px !important;
  padding: 10px 0 !important;
}
.van-tabbar-item {
  background-color: #fff;
}
.van-tabbar-item__icon img {
  height: 22px;
}
.van-tabbar-item--active img {
  height: 24px;
}
</style>
